(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientDialogController', PatientDialogController);

    PatientDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Patient', 'User', 'SurveyResult'];

    function PatientDialogController ($scope, $stateParams, $uibModalInstance, $q, entity, Patient, User, SurveyResult) {
        var vm = this;
        vm.patient = entity;
        vm.users = User.query();
        vm.surveyresults = SurveyResult.query();
        vm.load = function(id) {
            Patient.get({id : id}, function(result) {
                vm.patient = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:patientUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patient.id !== null) {
                Patient.update(vm.patient, onSaveSuccess, onSaveError);
            } else {
                Patient.save(vm.patient, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateOfBirth = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
